// extracted by mini-css-extract-plugin
export default {"brandsWrapper":"brands_brandsWrapper__XtaVY","brandsContainer":"brands_brandsContainer__DJw-w","brand":"brands_brand__eYl3S","brandLogo":"brands_brandLogo__KAgqA"};